module.exports = __webpack_public_path__ + "static/about-img2-119d26ffb3d6b57e82f467043a387921.webp";